import CountRegister from './messages_counters_register/CountRegister';

export default class MessagesCountersRegisters {
  private _assistant: CountRegister;
  private _user: CountRegister;

  constructor(assistant: CountRegister, user: CountRegister) {
    this._assistant = assistant;
    this._user = user;
  }

  get assistant(): CountRegister {
    return this._assistant;
  }

  get user(): CountRegister {
    return this._user;
  }

  public copyWith({
    assistant,
    user,
  }: {
    assistant?: CountRegister;
    user?: CountRegister;
  }): MessagesCountersRegisters {
    return new MessagesCountersRegisters(
      assistant ?? this._assistant,
      user ?? this._user
    );
  }

  static fromFirestoreMap(
    data: Record<string, any>
  ): MessagesCountersRegisters {
    const empty = () => new CountRegister(0, 0);
    return new MessagesCountersRegisters(
      data?.assistant ? CountRegister.fromFirestoreMap(data.assistant) : empty(),
      data?.user ? CountRegister.fromFirestoreMap(data.user) : empty()
    );
  }
}
